import styled from 'styled-components';

import { UI_COLORS, CHART_TITLE_COLOR } from '../../../utils/colors';
import { propCond } from '../../../utils/propCond';
import { always, equals } from 'ramda';
import { ARC_STATES } from './radialChart.constants';
import { media } from '../../../utils/media';

export const Label = styled.text`
  font-size: 0.51em;
  font-family: sans-serif;
  text-anchor: middle;
  alignment-baseline: middle;
  fill: ${UI_COLORS[4]};
`;

export const IndicatorColor = styled.div`
  width: 20px;
  height: var(--indicator-height);
  background-color: ${({ color }) => color};
`;

export const IndicatorLabel = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  margin-left: 5px;
  height: var(--indicator-height);
  width: 25px;
  background-color: #ffffff33;
  display: flex;
  align-items: center;
  line-height: 1.05em;
  padding: 0 5px;
`;

export const LegendItem = styled.div`
  display: flex;
`;

export const LegendGroupTitle = styled.div`
  text-transform: uppercase;
  font-size: 9px;
  line-height: 1em;
  margin: 5px 0;
  width: 50px;

  :first-child {
    margin-top: 0;
  }

  ${media.desktop`
    font-size: 10px;
    margin: 8px 0;
  `}
`;

export const LegendBox = styled.div`
  --indicator-height: 24px;
  border: 1px solid ${({ gridStroke }) => gridStroke};
  padding: 8px;
  max-height: calc(100% - 8px);
  overflow-y: auto;

  ${IndicatorLabel} {
    border-bottom: 1px solid ${({ gridStroke }) => gridStroke};
  }

  ${LegendItem}:nth-of-type(2) ${IndicatorLabel}, ${LegendItem}:last-of-type ${IndicatorLabel} {
    border-top: 1px solid ${({ gridStroke }) => gridStroke};
  }

  ${media.desktop`
    overflow-y: hidden;
  `}
`;

export const LegendTitle = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  line-height: 1em;
  text-align: center;
  margin-bottom: 1px;

  ${media.desktop`
    font-size: 14px;
    margin-top: 8px;
  `}
`;

export const RadialLegend = styled.div`
  display: block;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  color: ${CHART_TITLE_COLOR};
`;

const arcOpacity = propCond('hoverState')([
  [equals(ARC_STATES.NORMAL), always(1)],
  [equals(ARC_STATES.ACTION_HOVER), always(1)],
  [equals(ARC_STATES.ACTION_NO_HOVER), always(0.2)],
]);

export const Arc = styled.path`
  opacity: ${arcOpacity};
  transition: opacity 0.1s;
`;
